import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Cancelled from "../common/Cancelled";

const CampaignCancelled = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id } = log.dataSnapshot.campaign;
  const { updatedBy, updatedAt } = log.changedFields?.campaign || {};
  return <Cancelled name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default CampaignCancelled;
